import React from 'react';

const InfoSection = ({
  displayData,
  handleUserInfoChange
}) => {
  return (
    <div style={{ marginTop: '20px' }}>
      <h3 style={{ 
        margin: '0 0 15px 0', 
        fontSize: '16px', 
        fontWeight: '600', 
        color: '#333'
      }}>
        Информация
      </h3>
      
      <div style={{ 
        border: '1px solid #dee2e6',
        borderRadius: '6px',
        backgroundColor: '#fff'
      }}>
        <table style={{
          width: '100%',
          minWidth: '800px',
          borderCollapse: 'collapse',
          fontSize: '12px'
        }}>
          <thead>
            <tr style={{ backgroundColor: '#f8f9fa' }}>
              <th style={{ 
                minWidth: '800px', 
                width: '800px',
                padding: '8px',
                border: '1px solid #dee2e6',
                textAlign: 'center',
                fontWeight: '600'
              }}>
                Информация пользователя
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ 
                padding: '8px',
                border: '1px solid #dee2e6',
                textAlign: 'center',
                fontWeight: '500'
              }}>
                <textarea
                  value={displayData.itaks5 || ''}
                  onChange={handleUserInfoChange}
                  placeholder="Введите дополнительную информацию..."
                  style={{
                    width: '100%',
                    minHeight: '40px',
                    padding: '8px',
                    border: 'none',
                    borderRadius: '0',
                    fontSize: '14px',
                    fontFamily: 'inherit',
                    resize: 'vertical'
                  }}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default InfoSection;

